export default "/images/d9f1ac8c33b468e53a15555c2e2bd267.avif";